module.exports = __webpack_public_path__ + "img/IMG_1830.f305ce8f.jpg";